export default ['en', 'id'];
